import { FETCH_STEEL_SMELTER_ALL_MAP_DATA } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_STEEL_SMELTER_ALL_MAP_DATA:
			return action.payload;
		default:
			return state;
	}
};
